import axios from "axios";
import { server } from "../../server";


// get all orders of delivery partner
export const getAllOrderStatusOfDelivery = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllOrderStatusDeliveryRequest",
    });

    const { data } = await axios.get(
      `${server}/order-status/get-order-status-delivery-partner`,
      {
        withCredentials: true,
      }
    );

    dispatch({
      type: "getAllOrderStatusDeliverySuccess",
      payload: data.orderStatus,
    });
  } catch (error) {
    dispatch({
      type: "getAllOrderStatusDeliveryFailed",
      payload: error.response.data.message,
    });
  }
};
